import { selectExperiments } from './experiments';
import { IApplicationState } from '../../types/redux';
import { isMultipinsExpActive } from '../../utils/experiments/isMultipinsExpActive';

export const selectIsMultipinsExpActive = (state: IApplicationState): boolean => {
  return isMultipinsExpActive(selectExperiments(state));
};
